
export default {
  name: 'AppTag',
  props: {
    label: {
      type: String,
      required: true
    },
    forcedDevice: {
      type: String,
      default: null,
      validator: v => ['pc', 'mobile'].includes(v)
    }
  }
};
